import { render, staticRenderFns } from "./orderListXyf.vue?vue&type=template&id=6d9f2f8a&scoped=true&"
import script from "./orderListXyf.vue?vue&type=script&lang=js&"
export * from "./orderListXyf.vue?vue&type=script&lang=js&"
import style0 from "./orderListXyf.vue?vue&type=style&index=0&id=6d9f2f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9f2f8a",
  null
  
)

export default component.exports